import { useState, useEffect } from 'react';
import { Button, Flex, theme, Icon, loadingSpinner } from '../../../2022-component-library';
import { useCalibration } from '../../../context/calibrationContext';
import { useReceiveMessage, usePostMessage } from '../../../context/messageContext';
import { calibrationConstants } from '../../../helpers/calibration-constants';

const ResponsivePupillaryDistanceOptician = () => {
  const [startedDetection, setStartedDetection] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  const postMessage = usePostMessage();
  const messageFromPatient = useReceiveMessage();
  const { tangent15degrees } = calibrationConstants;
  const {
    calibrationData: { distanceFromScreen, pixelDensity },
    updateCalibrationData,
  } = useCalibration();

  const toggleDetection = () => {
    let type = 'startPupillaryDistanceDetection';
    if (startedDetection) {
      type = 'stopPupillaryDistanceDetection';
    }
    postMessage({
      type: type,
    });
    setStartedDetection(!startedDetection);
    setIsMoving(false);
  };

  useEffect(() => {
    if (messageFromPatient?.type === 'patientMovementDetected') {
      setIsMoving(messageFromPatient.content.patientIsMoving);
      setStartedDetection(messageFromPatient.content.patientIsMoving);
      updateCalibrationData({ distanceFromScreen: messageFromPatient.content.patientDistance });
      const blindSpotVanishingXDistanceMm = parseInt(messageFromPatient.content.patientDistance) * tangent15degrees;

      const newCalibrationData = {
        blindSpotVanishingXDistancePx: blindSpotVanishingXDistanceMm / pixelDensity,
        distanceFromScreen: parseInt(messageFromPatient.content.patientDistance),
      };

      updateCalibrationData(newCalibrationData);
    }
  }, [messageFromPatient, tangent15degrees, updateCalibrationData, pixelDensity]);

  return (
    <Flex column centered>
      <Button
        marginBottom='10px'
        onClick={() => {
          toggleDetection();
        }}
        backgroundColor={startedDetection ? theme.colors.negativeDark : theme.colors.darkGreen}
      >
        {!startedDetection ? 'Start detection' : 'Stop detection'}
      </Button>
      <Flex flexDirection='column' alignItems='center' justifyContent='center'>
        <Flex flexDirection='column' alignItems='center' justifyContent='center'>
          <Flex fontSize='16px' marginBottom='10px'>
            {isMoving ? 'Collecting distance...' : 'Collected distance'}
          </Flex>
          {isMoving ? (
            <Flex>
              <Icon icon={loadingSpinner} />
            </Flex>
          ) : (
            <Flex fontSize='16px' fontWeight='bold'>
              {distanceFromScreen.toFixed() + 'mm'}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResponsivePupillaryDistanceOptician;
